import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "9",
  height: "16",
  viewBox: "0 0 9 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.2955 15.1705C8.73483 14.7312 8.73483 14.0188 8.29549 13.5795L2.71599 8.00003L8.2955 2.42049C8.73484 1.98115 8.73483 1.26884 8.29549 0.829503C7.85615 0.390164 7.14384 0.390165 6.7045 0.829507L0.329502 7.20454C-0.109836 7.64388 -0.109834 8.35619 0.329506 8.79553L6.70451 15.1705C7.14385 15.6098 7.85616 15.6098 8.2955 15.1705Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }